import uuidv4 from 'uuid/v4';

export const isQuestionDeletableKey = `is-question-deletable-${uuidv4()}`;
